<template>
    <div class="ruleListBox">
        <md-field>
            <md-cell-item v-for="(item) in ruleData" :title="item.topic" :key="item.id" @click="gotoRule(item.id, 1)"  arrow />
            <md-cell-item v-for="(item) in ruleData2" :title="item.topic" :key="item.id" @click="gotoRule(item.id, 2)"  arrow />
        </md-field>
    </div>
</template>

<script>
    export default {
        name: "serviceContentList",
        data(){
            return{
                ruleData:[],
                ruleData2:[]
            }
        },
        mounted() {
            document.title = "服务中心"
            let dt = new URLSearchParams()
            dt.append('contentClass', 'SERVICE_CENTER')
            dt.append('status', 2)
            this.$http.get('/sangto-wrm/base/content/page', dt).then(({data})=>{

                this.ruleData =data.data.rows
            })
            this.$http.post('/system/base/content/page', dt).then(({data})=>{

                this.ruleData2 =data.data.rows
            })
        },
        methods:{
            gotoRule(item, index){

                    this.$router.push({path:'/serviceContent', query:{itemData:JSON.stringify(item), id: index}})




            }
        }
    }
</script>

<style scoped lang="scss">
    .ruleListBox{
        position: relative;
        width: 100%;
        height: 100%;
        background-color: #fff;
    }
</style>
